<template>
    <RequestPropousalUpdate/>
  </template>
  
  <script>
  import RequestPropousalUpdate from './RequestProposalUpdate.vue'
  export default {
    components: {
        RequestPropousalUpdate
    },
    data () {
      return {
  
      }
    },
    created () {
      this.$store.commit('updateTitle', 'Cambios de Turnos Manuales')
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/UpdateTurn.vue